import React, { useState, useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Contacts from "../../views/app/Contacts";
import Messages from "../../views/app/Messages";
import VoiceMail from "../../views/app/VoiceMail";
import MissedCalls from "../../views/app/MissedCalls";
import WaitTime from "../../views/app/WaitTime";
import Reminders from "../../views/app/Reminders";
import Profile from "../../views/app/Setting/Profile";
import Payments from "../../views/app/Setting/Payments";
import Templates from "../../views/app/Templates";
import Preferences from "../../views/app/Setting/Preferences";
import BlockedNumbers from "../../views/app/Setting/BlockedNumbers";
import Employees from "../../views/app/Setting/Employees";
import VoicemailDestination from "../../views/app/Setting/VoicemailDestination";
import AuditLogs from "../../views/app/Setting/AuditLogs";
import ChangePassword from "../../views/app/Setting/ChangePassword";
import DashboardPage from "../../views/app/Dashboard/index";
import { useDispatch, useSelector } from "react-redux";
import ImportContacts from "../../views/app/Setting/ImportContacts";
import { isAdminUser, isRestrictedItem } from "../../redux/action";
import { useNavigate } from "react-router-dom";
import { continueLogin } from "../../redux/action";
import { fetchLatestTwilioStatus } from "../../redux/action";
import { signoutUser } from "../../redux/action";
import {
  Button,
  Text,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "@chakra-ui/react";
import AiAssistant from "../../views/app/Setting/AiAssistant";
function Main() {
  const dispatch = useDispatch();
  const [statusValue, setStatusValue] = useState("");
  const { isOpen, onOpen, onClose } = useDisclosure();
  const navigate = useNavigate();
  const authUser = useSelector((state) => state.authUser);
  const checkAccountIssues = (currentPage) => {
    // const { match } = this.props;
    // const location = useLocation();
    let employeeRestricted = [
      "profile",
      "settings",
      "payments",
      "audit-logs",
      "import-contacts",
      "employees",
      "voicemail-transcript",
      "blocked-numbers",
    ];
    // let user = JSON.parse(localStorage.getItem("user"))
    // console.log("location", user);
    const { user, activeAccount } = authUser;
    const { accounts } = user;

    if (!accounts?.length && currentPage == "/") {
      localStorage.removeItem("user_id");
      localStorage.removeItem("user");
      localStorage.removeItem("login");
      localStorage.removeItem("activeAccount");
      alert("You are not a part of any account");
      window.location = "/";
    }
    let activeAccountData = accounts?.find((x) => x.id == activeAccount);
    let { subscription_status } = activeAccountData;
    if (
      !activeAccountData?.phone &&
      currentPage != "profile" &&
      dispatch(isAdminUser())
    ) {
      alert(
        "Please select your business phone in profile, by pressing ok you will be redirected to profile. Thank you"
      );

      return <Navigate to={`/profile`} />;
      //navigate("/profile");
      // return Business phone not setup
    } else if (
      (!subscription_status ||
        [
          "incomplete_expired",
          "past_due",
          "canceled",
          "unpaid",
          "expired",
        ].indexOf(subscription_status) != -1) &&
      currentPage != "payments"
    ) {
      // Payment Issue
      alert(
        "Your account is blocked because of a payment issue. Please see your payments section or contact admin for details. Thank you"
      );

      return <Navigate to={`/payments`} />;
    } else if (
      !dispatch(isAdminUser()) &&
      employeeRestricted.indexOf(currentPage) !== -1
    ) {
      return <Navigate to={`/`} />;
    } else if (!dispatch(isRestrictedItem({ id: "none", to: currentPage }))) {
      return <Navigate to={`/`} />;
    }
    return false;
  };

  useEffect(() => {
    onOpen();
    setStatusValue(authUser?.twilioStatus);
  }, [authUser?.twilioStatus]);

  useEffect(() => {
    if (authUser?.twilioStatus != "ready") dispatch(fetchLatestTwilioStatus());
  }, []);

  return (
    <div className="px-2 px-md-4">
      {statusValue != "ready" && (
        <Modal
          size="lg"
          closeOnEsc={false}
          closeOnOverlayClick={false}
          isOpen={isOpen}
          onClose={() => {}}
          // onClose={onClose}
          isCentered
        >
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>
              {(authUser?.twilioStatus == "completed" ||
                authUser?.twilioStatus == "testing") &&
                "Congratulations,Your account is successfully created. "}
              {authUser?.twilioStatus == "failed" &&
                "Sorry, Your hosted number request is failed."}
              {authUser?.twilioStatus == "received" &&
                "Account Status, Your request is under processing."}
              {authUser?.twilioStatus == "pending-loa" &&
                "Required action for document sign."}
              {authUser?.twilioStatus == "carrier-processing" &&
                "Account Status, Your account will be active in 24 hours."}
            </ModalHeader>
            {/* <ModalCloseButton /> */}
            <ModalBody>
              <Text>
                {(authUser?.twilioStatus == "completed" ||
                  authUser?.twilioStatus == "testing") &&
                  "Please click on continue button."}
                {authUser?.twilioStatus == "failed" &&
                  "Due to some reasons, your number cannot be hosted on twilio. Please contact our support team."}
                {authUser?.twilioStatus == "received" &&
                  "Please wait 24 hours."}
                {authUser?.twilioStatus == "pending-loa" &&
                  "Please check your email and sign the document."}
                {authUser?.twilioStatus == "carrier-processing" &&
                  "Please wait 24 hours."}
              </Text>
            </ModalBody>
            <ModalFooter>
              <Button
                variant="ghost"
                colorScheme="blue"
                mr={3}
                onClick={() => {
                  onClose();
                  dispatch(signoutUser());
                  navigate("/login");
                }}
              >
                Logout
              </Button>
              {(authUser?.twilioStatus == "completed" ||
                authUser?.twilioStatus == "testing") && (
                <Button
                  variant="solid"
                  colorScheme="blue"
                  onClick={() => {
                    onClose();
                    dispatch(continueLogin());
                  }}
                >
                  Continue
                </Button>
              )}
            </ModalFooter>
          </ModalContent>
        </Modal>
      )}
      <Routes>
        <Route path="/" element={<DashboardPage />} />
        <Route path="/contacts" element={<Contacts />} />
        <Route
          path="/messages"
          element={
            (window.location.pathname == "/messages" &&
              checkAccountIssues("messages")) || <Messages />
          }
        />
        <Route
          path="/voicemail"
          element={
            (window.location.pathname == "/voicemail" &&
              checkAccountIssues("voicemail")) || <VoiceMail />
          }
        />
        <Route
          path="/missed-calls"
          element={
            (window.location.pathname == "/missed-calls" &&
              checkAccountIssues("missed-calls")) || <MissedCalls />
          }
        />
        <Route
          path="/wait-time"
          element={
            (window.location.pathname == "/wait-time" &&
              checkAccountIssues("wait-time")) || <WaitTime />
          }
        />
        <Route
          path="/templates"
          element={
            (window.location.pathname == "/templates" &&
              checkAccountIssues("templates")) || <Templates />
          }
        />
        <Route
          path="/reminders"
          element={
            (window.location.pathname == "/reminders" &&
              checkAccountIssues("reminder")) || <Reminders />
          }
        />
        <Route
          path="/profile"
          element={
            (window.location.pathname == "/profile" &&
              checkAccountIssues("profile")) || <Profile />
          }
        />
        <Route
          path="/payments"
          element={
            (window.location.pathname == "/payments" &&
              checkAccountIssues("payments")) || <Payments />
          }
        />
        <Route
          path="/templates"
          element={
            (window.location.pathname == "/templates" &&
              checkAccountIssues("templates")) || <Templates />
          }
        />
        <Route
          path="/preferences"
          element={
            (window.location.pathname == "/preferences" &&
              checkAccountIssues("preferences")) || <Preferences />
          }
        />
        <Route
          path="/blocked-numbers"
          element={
            (window.location.pathname == "/blocked-numbers" &&
              checkAccountIssues("blocked-numbers")) || <BlockedNumbers />
          }
        />
        <Route
          path="/employees"
          element={
            (window.location.pathname == "/employees" &&
              checkAccountIssues("employees")) || <Employees />
          }
        />
        <Route
          path="/voicemail-destination"
          element={
            (window.location.pathname == "/voicemail-destination" &&
              checkAccountIssues("voicemail-destination")) || (
              <VoicemailDestination />
            )
          }
        />
        <Route
          path="/audit-logs"
          element={
            (window.location.pathname == "/audit-logs" &&
              checkAccountIssues("audit-logs")) || <AuditLogs />
          }
        />
        <Route path="/change-password" element={<ChangePassword />} />
        <Route path="/ai-assistant" element={<AiAssistant />} />

        <Route
          path="import-contacts"
          element={
            (window.location.pathname == "/import-contacts" &&
              checkAccountIssues("import-contacts")) || <ImportContacts />
          }
        />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </div>

    // <Router>
    //   {/* <Switch>
    //     <Route path="/conta">
    //       <DashboardHome />
    //     </Route>
    //   </Switch> */}
    // </Router>
  );
}

export default Main;
